import {
  MoreHorizontal as MoreHorizontalIcon,
  Check as CheckIcon,
  AlertTriangle as AlertTriangleIcon,
  Clock as ClockIcon,
} from 'react-feather'

const PENDING_STATUS = 'pending'
const IN_PROGRESS_STATUS = 'in_progress'
const CONCLUDED_STATUS = 'concluded'
const OVERDUE_STATUS = 'overdue'

const QUIZ_STATUS_LABEL = {
  [PENDING_STATUS]: 'Pendente',
  [IN_PROGRESS_STATUS]: 'Em Andamento',
  [CONCLUDED_STATUS]: 'Concluído',
  [OVERDUE_STATUS]: 'Atrasado',
}

const PROGRESS_STATUS_BUTTONS = [
  {
    id: null,
    name: 'Todas',
    value: null,
  },
  {
    id: PENDING_STATUS,
    name: 'Pendentes',
    icon: MoreHorizontalIcon,
    value: PENDING_STATUS,
  },
  {
    id: IN_PROGRESS_STATUS,
    name: 'Em Andamento',
    icon: ClockIcon,
    value: IN_PROGRESS_STATUS,
  },
  {
    id: OVERDUE_STATUS,
    name: 'Atrasadas',
    icon: AlertTriangleIcon,
    value: OVERDUE_STATUS,
  },
  {
    id: CONCLUDED_STATUS,
    name: 'Concluídas',
    icon: CheckIcon,
    value: CONCLUDED_STATUS,
  },
]

const PROGRESS_STATUS_COLOR = {
  [PENDING_STATUS]: '#233154',
  [IN_PROGRESS_STATUS]: '#0763A0',
  [OVERDUE_STATUS]: '#E83A494D',
  [CONCLUDED_STATUS]: '#80B92B',
}

const QUIZ_STATUS_COLOR = {
  [PENDING_STATUS]: '#9E9E9E',
  [IN_PROGRESS_STATUS]: '#0763A0',
  [CONCLUDED_STATUS]: '#80B92B',
  [OVERDUE_STATUS]: '#E53935',
}

const PROGRESS_STATUS_ICON = {
  [PENDING_STATUS]: MoreHorizontalIcon,
  [IN_PROGRESS_STATUS]: ClockIcon,
  [OVERDUE_STATUS]: AlertTriangleIcon,
  [CONCLUDED_STATUS]: CheckIcon,
}

export default {
  OVERDUE_STATUS,
  PENDING_STATUS,
  PROGRESS_STATUS_BUTTONS,
  PROGRESS_STATUS_COLOR,
  PROGRESS_STATUS_ICON,
  QUIZ_STATUS_COLOR,
  QUIZ_STATUS_LABEL,
}
